import { Component, Input, HostBinding, Output, EventEmitter, OnInit } from '@angular/core';
import { ProgressStep } from './progress-step.interface';

@Component({
  selector: 'suka-progress',
  template: `
    <div class="mobile-progress">
      <div class="mobile-progress__label">
        <h3 class="mobile-progress__label__current-step">{{currentStep().label}}</h3>
        <p class="mobile-progress__label__next-step" *ngIf="getCurrentStepIndex() + 1 < steps.length">PrÃ³ximo paso: {{nextStep().label}}</p>
        <p class="mobile-progress__label__next-step" *ngIf="getCurrentStepIndex() + 1 >= steps.length">Ãltimo paso</p>
      </div>

      <div
        class="mobile-progress__status"
        [ngClass]="[
          'radial-progress-' + (getCurrentStepIndex() + 1) * 100 / steps.length
        ]"
      >
        <div class="mobile-progress__status-overlay">
          {{getCurrentStepIndex() + 1}} de {{steps.length}}
        </div>
      </div>
    </div>
    <div class="progress__wrapper">
      <ul class="progress-bar">
        <li
          *ngFor="let step of steps; let i = index"
          class="progress-bar__step"
          [ngClass]="{
            'progress-bar__step--complete': isComplete(step),
            'progress-bar__step--editable': isEditable(step),
            'progress-bar__step--error': step.state === 'error',
            'progress-bar__step--current': step.current,
            'progress-bar__step--unclickable': isUnclickable(step, i)
          }"
        >
          <div class="step" role="button" (click)="select(i)">
            <div class="step__indicator">
              <ng-container *ngIf="step.state !== 'complete' || step.current">{{ i + 1 }}</ng-container>
              <suka-icon icon="check" *ngIf="isComplete(step) && !isEditable(step) && !step.current"></suka-icon>
              <suka-icon icon="edit-2" *ngIf="isEditable(step) && !step.current"></suka-icon>
            </div>
            <span class="step__label"> {{ step.label }}</span>
          </div>
        </li>
      </ul>
    </div>
  `
})
export class Progress {
  private _steps: Array<ProgressStep>;

  @HostBinding('class.progress') baseClass = true;

  /**
   * Set to `true` to make the progress linear. This allows the user to access any of the steps at any time (like tabs).
   */
  @Input() linear = false;

  /**
   * Set to `true` to allow the user to edit a step after completed.
   */
  @Input() editable = false;

  /**
   * Emits an event when a index is selected
   */
  @Output() selected = new EventEmitter();

  /**
   * Emits an event when the steps change.
   */
  @Output() stepsChange = new EventEmitter();
  /**
   * Sets the steps for the `Progress` component.
   */
  @Input() get steps() {
    return this._steps;
  }
  set steps(value) {
    this._steps = value;

    this.stepsChange.emit(this._steps);
  }

  select(newIndex): void {
    this._steps.forEach((step, index) => {
      if (index === newIndex) {
        step.current = true;
      } else if (step.current) {
        delete step.current;
      }
    });

    this.selected.emit(newIndex);

    this.steps = this._steps;
  }

  /**
   * Step is completed.
   */
  isComplete(step: ProgressStep) {
    return step.state === 'complete';
  }

  /**
   * Step is editable.
   */
  isEditable(step: ProgressStep) {
    return step.state === 'complete' && this.editable;
  }

  /**
   * Step is unclickable.
   */
  isUnclickable(step: ProgressStep, index: number): boolean {
    if (step.state === 'complete' && !this.editable) {
      return true;
    }
    if (step.state === 'incomplete' && !this.linear && index !== this.getNextUncompletedStepIndex()) {
      return true;
    }

    return false;
  }

  /**
   * Returns the index of the next uncompleted step.
   */
  getNextUncompletedStepIndex(): number {
    for (const [index, step] of this.steps.entries()) {
      if (step.state === 'incomplete') {
        return index;
      }
    }

    return -1;
  }


  /**
   * Returns the current step.
   */
  currentStep() {
    for (const [_, step] of this.steps.entries()) {
      if (step.current) {
        return step;
      }
    }

    return null;
  }

  /**
   * Returns the next step.
   */
  nextStep() {
    let currentIndex = -1;

    for (const [index, step] of this.steps.entries()) {
      if (step.current) {
        currentIndex = index;
      }
      if (currentIndex >= 0 && currentIndex + 1 === index) {
        return step;
      }
    }

    return null;
  }

  /**
   * Returns the current step index.
   */
  getCurrentStepIndex() {
    for (const [index, step] of this.steps.entries()) {
      if (step.current) {
        return index;
      }
    }

    return -1;
  }
}
